import React from 'react';
import styled from 'styled-components';
import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

const Container = styled.div`
  margin: ${({ theme }) => theme.spacing(10, 0, 8, 0)};
  height: 18px;
`;

const SectionTitle = () => (
  <Container>
    <Skeleton height="4" width="136" />
  </Container>
);

export default SectionTitle;
